import ResetPassword from '../components/ResetPassword/index';

const ResetPasswordView = () => {
    return <ResetPassword />;
};

export default ResetPasswordView;
